// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import i18n from '@/lang/lang';
import store from '@/store';
import EventBus from '@/components/shared/eventbus';
import VARIABLES from '@/components/shared/variables';
import AudioPlayer from '@/components/shared/audio';
import PasswordValidator from 'password-validator';
import VueClipboard from 'vue-clipboard2';
import Vue2TouchEvents from 'vue2-touch-events';
import VueDraggable from 'vue-draggable';
import Croppa from 'vue-croppa';
import lineClamp from 'vue-line-clamp';
import VueCookies from 'vue-cookies';
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';
import BootstrapVue from 'bootstrap-vue';
import anime from 'animejs';
import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';
import VueGtag from 'vue-gtag';
import Hotjar from 'vue-hotjar';
import App from './App';
import router from './router';

Vue.use(VueCookies);

Vue.$cookies.config('365d');

// eslint-disable-next-line new-cap
const passwordValidatorSchema = new PasswordValidator();

const urlSearchParams = new URLSearchParams(location.search);
const params = Object.fromEntries(urlSearchParams.entries());

if (!params.code && !params.scope && !params.session_state) {
  // eslint-disable-next-line global-require
  const HelloJs = require('hellojs');
  // eslint-disable-next-line global-require
  const VueHello = require('vue-hellojs');

  HelloJs.init(
    {
      facebook: process.env.VUE_APP_CLIENT_ID_FACEBOOK,
      google: process.env.VUE_APP_CLIENT_ID_GOOGLE
    },
    { redirect_uri: '/users/login' }
  );

  Vue.use(VueHello, HelloJs);
}

passwordValidatorSchema
  .is()
  .min(5)
  .is()
  .max(20)
  .has()
  .lowercase()
  .has()
  .digits()
  .has()
  .not()
  .spaces();

Vue.use(require('vue-moment'));

Vue.use(lineClamp);
Vue.config.productionTip = false;

Vue.use(VueDraggable);
Vue.use(BootstrapVue);
Vue.use(Croppa);
Vue.use(VTooltip);
Vue.use(VueClipboard);
Vue.use(Vue2TouchEvents);

Vue.directive('tooltip', VTooltip);
Vue.directive('close-popover', VClosePopover);
Vue.component('v-popover', VPopover);

Vue.prototype.$eventBus = EventBus;
Vue.prototype.$uuid = uuidv4;
Vue.prototype.$anime = anime;
Vue.prototype.$VARIABLES = VARIABLES;
Vue.prototype.$passwordValidator = passwordValidatorSchema;
Vue.prototype.$audio = AudioPlayer;

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn:
      'https://3368a224815d44aea17f4b54cac1a11a@o462477.ingest.sentry.io/4503964959178752',
    integrations: [
      new VueIntegration({
        Vue,
        logErrors: true
      })
    ]
  });
} else {
  // eslint-disable-next-line no-console
  console.debug('Not configuring Sentry, environment is', process.env.NODE_ENV);
}

const user = store.getters['users/getLoggedInUserProfile'];
const isDktUser = user && user.provider === 'idp';
if (!location.pathname.split('/')[1].includes('dkt') && !isDktUser) {
  Vue.use(Hotjar, {
    id: '2047464',
    isProduction: process.env.NODE_ENV === 'production'
  });
}
// HelloJs.init({
//   facebook: '523468784958852',
//   google: '451850595890-bcv2ci7frc1smoe0gh11g673ib37vb2a.apps.googleusercontent.com'
// }, { redirect_uri: '/' });

const fixIdScrolling = {
  watch: {
    $route(to, from) {
      const currentRoute = this.$router.currentRoute;
      const idToScrollTo = currentRoute.hash;
      this.$nextTick(() => {
        if (idToScrollTo && document.querySelector(idToScrollTo)) {
          document.querySelector(idToScrollTo).scrollIntoView();
        }
      });
    }
  }
};

Vue.use(
  VueGtag,
  {
    config: { id: 'G-0BSFNNGRG9', account_id: '246755993' },
    // disableScriptLoad: process.env.NODE_ENV !== 'production' || store.getters['users/isDktUser'],
    disableScriptLoad: store.getters['users/isDktUser'],
    pageTrackerTemplate(to) {
      return {
        page_title: to.name,
        page_path: to.path
      };
    }
  },
  router
);

Vue.prototype.$anime = anime;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  mixins: [fixIdScrolling],
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js